import './style.less';
import { emailTemplates } from '@prolaera/library';
import { keyBy } from 'lodash';

export default function($log, $state, $stateParams, ProfileClass, ApiClass, Swal) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  const emailTemplatesDict = keyBy(emailTemplates, 'id');

  vm.submit = formData => {
    vm.submitButton = true;
    ApiClass.companiesIdTypeTypeIdPatch(
      { manage: true, id: company_id, type: 'emailTemplates', type_id: $stateParams.type_id },
      formData
    )
      .then(() => {
        Swal.toast('Email Template information has been saved');
        vm.submitButton = false;
        $state.go('^');
      })
      .catch(error => {
        vm.submitButton = false;
        $log.error(error);
        throw error;
      });
  };

  /**
   * Sets the any undefined eventInfoOptions to true
   *
   * @param {*} param0
   * @returns
   */
  function _eventInfoOptionsDefaults({ eventInfoOptions: optionsMap = {} }) {
    const eventInfoOptions = Object.keys(optionsMap).reduce((acc, key) => {
      if (optionsMap[key]) {
        acc[key] = true;
      }

      return acc;
    }, {});

    return Object.keys(eventInfoOptions).length ? { eventInfoOptions } : {};
  }

  function _loadEmailTemplate() {
    return ApiClass.companiesIdTypeTypeIdGet({
      manage: true,
      id: company_id,
      type: 'emailTemplates',
      type_id: $stateParams.type_id
    })
      .then(({ data: { item } }) => {
        vm.formData = {
          ...vm.formData,
          ...item
        };
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }

  function activate() {
    $log.debug('Email Template Controller Activated');
    vm.submitButton = false;

    const templateFields = emailTemplatesDict[$stateParams.type_id];

    vm.formData = {
      ...templateFields,
      ..._eventInfoOptionsDefaults(templateFields.form)
    };

    _loadEmailTemplate();
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/emailTemplates/edit/index.js